/* eslint-disable */
import { DbUploadStatus } from '../dto/db-upload-status';

export interface DbUploadInfoDto {
  id: number;
  customerId: string;
  customerName: string;
  uploadStatus: DbUploadStatus;
  fileSize?: number | null;
  blobPath?: string | null;
  uploadActivatedAt: Date;
}

export const fixDbUploadInfoDtoFromJson = (dto?: DbUploadInfoDto | null): void => {
  if (!dto) {
    return;
  }
  dto.uploadActivatedAt = dto.uploadActivatedAt && new Date(dto.uploadActivatedAt);
};

export const fixDbUploadInfoDtoToJson = (dto?: DbUploadInfoDto | null): void => {
  if (!dto) {
    return;
  }
};
